import { createAction, props } from '@ngrx/store';
import { NextStepFilters } from '@shared/models/next-step-filters';

export const setNextStepsFilter = createAction(
  '[Next Steps] Set Next Steps Filter',
  props<{ filters: NextStepFilters }>(),
);
